// extracted by css-extract-rspack-plugin
module.exports =  {"list":"GroupChooser-YHAL__list","active":"GroupChooser-rCFR__active","is-favorite":"GroupChooser-KViz__is-favorite"};